import React, { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import config from "../config";

const API = config.API_BASE_URL;

// Click-wrap αποδοχή Όρων/Σύμβασης από admin του πελάτη (8/8/2026).
// Εμφανίζεται μόνο σε view_admin χρήστες όταν εκκρεμεί αποδοχή τρέχουσας έκδοσης.
export default function LegalAcceptGate({ user }) {
  const { t } = useTranslation();
  const [status, setStatus] = useState(null);
  const [open, setOpen] = useState(false);
  const [checked, setChecked] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!user) return;
    axios.get(`${API}/legal/status`).then((r) => setStatus(r.data)).catch(() => {});
  }, [user]);

  if (!status || !status.pending?.length || !status.canAccept) return null;

  const accept = async () => {
    setBusy(true);
    try {
      await axios.post(`${API}/legal/accept`, { types: status.pending });
      setStatus({ ...status, pending: [] });
      setOpen(false);
    } catch {
      // αφήνουμε το banner — θα ξαναπροσπαθήσει
    } finally {
      setBusy(false);
    }
  };

  const docLink = (type) => (
    <a key={type} href={`${API}/public/legal/${type}`} target="_blank" rel="noreferrer"
       style={{ color: "#1d4ed8", marginRight: 12 }}>
      {status.docs[type]?.title || type} ↗
    </a>
  );

  return (
    <>
      <div style={{
        position: "fixed", top: 64, left: "50%", transform: "translateX(-50%)",
        zIndex: 590, background: "#fffbeb", border: "1px solid #fcd34d", color: "#92400e",
        borderRadius: 10, padding: "8px 14px", fontSize: 13.5, display: "flex",
        gap: 10, alignItems: "center", maxWidth: "94vw", boxShadow: "0 2px 8px rgba(0,0,0,.08)",
      }}>
        <span>📄 {t("The service terms & contract need your acceptance.")}</span>
        <button onClick={() => setOpen(true)} style={{
          background: "#92400e", color: "#fff", border: "none", borderRadius: 8,
          padding: "5px 10px", cursor: "pointer", fontSize: 13, whiteSpace: "nowrap",
        }}>
          {t("Review & accept")}
        </button>
      </div>

      {open && (
        <div style={{
          position: "fixed", inset: 0, background: "rgba(0,0,0,.5)", zIndex: 1100,
          display: "flex", alignItems: "center", justifyContent: "center", padding: 16,
        }}>
          <div style={{ background: "#fff", borderRadius: 12, padding: 20, maxWidth: 460, width: "100%" }}>
            <h3 style={{ marginTop: 0 }}>{t("Terms & contract")}</h3>
            <p style={{ fontSize: 14, lineHeight: 1.6 }}>
              {t("Please review the documents below. Your acceptance is recorded (user, date, version) and a copy is emailed to your business.")}
            </p>
            <p style={{ fontSize: 14 }}>{status.pending.map(docLink)}</p>
            <label style={{ display: "flex", gap: 8, alignItems: "flex-start", fontSize: 13.5, margin: "10px 0" }}>
              <input type="checkbox" checked={checked} onChange={(e) => setChecked(e.target.checked)}
                     style={{ width: 18, height: 18, marginTop: 1 }} />
              <span>{t("I have read and accept the Terms of Service and the Service Contract (incl. the Data Processing Annex) on behalf of my business.")}</span>
            </label>
            <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
              <button onClick={() => setOpen(false)} style={{
                background: "#f3f4f6", border: "1px solid #d1d5db", borderRadius: 8,
                padding: "8px 14px", cursor: "pointer", fontSize: 14,
              }}>
                {t("Later")}
              </button>
              <button disabled={!checked || busy} onClick={accept} style={{
                background: checked ? "#111827" : "#9ca3af", color: "#fff", border: "none",
                borderRadius: 8, padding: "8px 14px", cursor: checked ? "pointer" : "default", fontSize: 14,
              }}>
                {t("Accept")}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
